import { useState, useEffect } from 'react';

import { useAuth } from '../../contexts/AuthContext';

import axios from 'axios';

const ForgotPasswordModal = ({ show, loginModal, onClose }) =>
{
    const [request, setRequest] = useState({ email: '' });
    const [errors, setErrors] = useState({ email: '' });
    const [loading, setLoading] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;

    const { setEmail, message, setMessage } = useAuth();

    const handleReset = () =>
    {
        setRequest({ email: '' });
        setErrors({ email: '' });

        setLoading(false);
        setMessage('');
    };

    const handleChange = (e) =>
    {
        setRequest(
        {
            ...request,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async (e) =>
    {
        e.preventDefault();

        setErrors({ email: '' });

        setLoading(true);

        try
        {
            const { data } = await axios.post(`${apiUrl}/usuarios-buscadores/forgot-password`, request);

            const message = data.message;

            setEmail(request.email);

            setMessage(message);

            setLoading(false);
        }
        catch (error)
        {
            const { response } = error;

            const { data } = response;

            setErrors(data.errors);

            setLoading(false);
        }
    }

    const handleLogin = () =>
    {
        onClose();

        loginModal();
    }

    useEffect(() =>
    {
        if (!show) { handleReset(); }
    }, [show]);

    if (!show) return null;

    return (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} style={{ backgroundColor: 'rgba(4, 47, 46, 0.75)', backdropFilter: 'blur(8px)', zIndex: 10050 }}>
            <div className="modal-dialog modal-md">
                <div className="modal-content">

                    <div className="modal-header">
                        <h5 className="modal-title fw-medium">{'Recuperar Contraseña'}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>

                    <form onSubmit={handleSubmit}>

                        <div className="modal-body">

                            {
                                message &&
                                (
                                    <div className="alert alert-primary text-center" role="alert">
                                        {message}
                                    </div>
                                )
                            }

                            <div className="mb-3">
                                <label style={{ fontSize: '12px', fontWeight: 600 }} htmlFor="email" className="form-label">{'Correo Electrónico'}</label>
                                <input 
                                    type="email"
                                    name="email"
                                    placeholder="Ingrese su correo"
                                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                    id="email"
                                    value={request.email}
                                    onChange={handleChange}
                                    required
                                    readOnly={message}
                                    autoComplete="off"
                                />

                                {
                                    errors.email &&
                                    (
                                        <div id="emailFeedback" className="invalid-feedback">
                                            {errors.email}
                                        </div>
                                    )
                                }

                            </div>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary px-4 uppercase fw-semibold" style={{ fontSize: '12px' }} onClick={handleLogin} disabled={loading}>{'Volver e iniciar sesión'}</button>
                            <button className="btn btn-primary fw-semibold bg-marine-600" style={{ fontSize: '12px' }} disabled={loading || message}>{`${!loading ? 'Recuperar contraseña' : 'Recuperando contraseña...'}`}</button>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    )
}

export default ForgotPasswordModal;
